module.exports = __webpack_public_path__ + "img/PMK_20240330_1.bb5bd664.jpg";